import type { Novidade } from './tipos';

/** Fase 2 (W26): escolher a agenda do Google de cada profissional ou recurso. */
export const novidadeAgendaGoogle: Novidade = {
  id: '2026-10-05-agenda-google',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'agenda',
  permissao: 'agenda.configurar',
  textos: {
    pt: {
      titulo: 'Escolha a agenda do Google de cada profissional',
      resumo: 'Com o Google Calendar conectado, cada profissional ou recurso sincroniza com a agenda do Google que você escolher.',
      passos: [
        'Conecte a conta Google em Integrações > Conectores > Google Calendar.',
        'Em Cadastros > Profissionais e recursos, abra o item e escolha a Agenda do Google.',
        'Os agendamentos vão para essa agenda, e os compromissos dela bloqueiam o horário aqui.',
        'Para parar, escolha Não sincronizar. O cartão do conector mostra quantos estão sincronizados.',
      ],
    },
    en: {
      titulo: 'Choose the Google calendar of each professional',
      resumo: 'With Google Calendar connected, each professional or resource syncs with the Google calendar you choose.',
      passos: [
        'Connect the Google account in Integrations > Connectors > Google Calendar.',
        'In Records > Staff and resources, open the item and choose the Google calendar.',
        'Appointments go to that calendar, and its events block the time here.',
        'To stop, choose Do not sync. The connector card shows how many are synced.',
      ],
    },
    es: {
      titulo: 'Elige el calendario de Google de cada profesional',
      resumo: 'Con Google Calendar conectado, cada profesional o recurso se sincroniza con el calendario de Google que elijas.',
      passos: [
        'Conecta la cuenta de Google en Integraciones > Conectores > Google Calendar.',
        'En Registros > Profesionales y recursos, abre el elemento y elige el Calendario de Google.',
        'Las citas van a ese calendario, y sus eventos bloquean el horario aquí.',
        'Para parar, elige No sincronizar. La tarjeta del conector muestra cuántos están sincronizados.',
      ],
    },
  },
  imagens: [null, '/novidades/2026-10-05-agenda-google/campo.webp', null, null],
  treinamento: { curso: 'novidades' },
  // Review r23 spec (O2): o texto é histórico; o link vai ao caminho novo (W31: Profissionais e recursos em Cadastros).
  rota: '/cadastros/agenda/recursos',
};
